/**
 * Whether the nurse's current contract record means "already signed".
 *
 * A signed contract never expires (the rollout set the item's `expiry_days` to
 * null), while every record still waiting for a signature carries a date: the
 * 30-day grace record the rollout seeded, or the same record after the daily
 * scan flipped it to `not_compliant` at the deadline. So "compliant with no
 * expiry date" is exactly "signed", and anything else still needs a signature.
 *
 * The screen needs this because it used to look identical before and after a
 * successful submit, and nurses signed again and again to be sure.
 */
export interface ContractRecordLike {
    status: string;
    expiryDate: string | null;
    verifiedAt: string | null;
}

export interface ContractSignState {
    signed: boolean;
    /** When the signature was recorded, if the record carries it. */
    signedAt: string | null;
}

export function contractSignState(record: ContractRecordLike | null): ContractSignState {
    if (!record || record.status !== "compliant" || record.expiryDate) {
        return { signed: false, signedAt: null };
    }
    return { signed: true, signedAt: record.verifiedAt };
}
